import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

import { Card } from '../card/Card';
import { FailedSubmissionCard } from '../FailedSubmission/FailedSubmissionCard/FailedSubmissionCard';
import { QueuedSubmissionCard } from '../QueuedSubmission/QueuedSubmissionCard/QueuedSubmissionCard';
import { Cell, Dashboard, EmptyCell } from './styles';

export const DashboardGrid = ({ items }: any) => {
  return (
    <Dashboard>
      {items.map((item: any) => (
        <Cell data-testid="vehicleCard" key={uniqueId('cell-')}>
          {item.status === ChecklightSessionStatus.QUEUED_FOR_SUBMISSION ? (
            <QueuedSubmissionCard {...item} />
          ) : item.status === ChecklightSessionStatus.FAILED_SUBMISSION ? (
            <FailedSubmissionCard {...item} />
          ) : (
            <Card {...item} />
          )}
        </Cell>
      ))}
      {/* 2 empty cells with gradient. They will be hidden when wrapped to a next line */}
      <EmptyCell data-testid="vehicleCard" />
      <EmptyCell data-testid="vehicleCard" />
    </Dashboard>
  );
};

DashboardGrid.propTypes = {
  items: PropTypes.any,
};
